import { useSeoMeta } from '@unhead/react';
import { ZenGame } from '@/components/zen/ZenGame';

const Index = () => {
  useSeoMeta({
    title: 'Zen Relay — a quiet introduction to Nostr',
    description:
      'A calm, minimal game that teaches the heart of Nostr: keys, signatures, relays, and follows. Five gentle lessons in two quiet minutes.',
  });

  return <ZenGame />;
};

export default Index;
